import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from 'react-bootstrap'

import { LoadingSpinner } from '../../components'

import ClassEngagement from './ClassEngagement'

export const renderLoading = () => {
  return (
    <div className="text-center">
      <LoadingSpinner />
    </div>
  )
}

export const renderError = () => {
  return (
    <Alert bsStyle="warning" className="text-center">
      Content failed to load
    </Alert>
  )
}

export const renderKnobs = statistics => {
  const {
    readingKnobMean,
    videosKnobMean,
    assessmentKnobMean,
    readingKnobColor,
    videosKnobColor,
    assessmentKnobColor,
  } = statistics

  return (
    <div>
      <ClassEngagement
        title="Reading"
        value={Math.round(readingKnobMean)}
        color={readingKnobColor}
      />
      <ClassEngagement
        title="Video"
        value={Math.round(videosKnobMean)}
        color={videosKnobColor}
      />
      <ClassEngagement
        title="Assessments"
        value={Math.round(assessmentKnobMean)}
        color={assessmentKnobColor}
      />
    </div>
  )
}

const OverallClassEngagement = props => {
  if (props.loading) {
    return renderLoading()
  } else if (props.error) {
    return renderError()
  } else {
    return renderKnobs(props.statistics)
  }
}

OverallClassEngagement.propTypes = {
  statistics: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
}

export default OverallClassEngagement
